import { ApolloClient } from '@apollo/client';
import { NormalizedCacheObject } from '@apollo/client';
import { loader } from 'graphql.macro';
import { ApolloClientCache } from 'common-types';
import { logger } from 'logging-utils';
import {
  GetPipelineSummaryInput,
  PipelineSummaryResponse,
} from '../../pipeline-summary-types';
const query = loader('./get-pipeline-summary.gql');

const getPipelineSummary = (client: ApolloClient<NormalizedCacheObject>) => {
  return {
    execute: async (
      getPipelineSummaryInput: GetPipelineSummaryInput,
      cache = true,
    ) => {
      try {
        const results = await client.query<{
          getPipelineSummary: PipelineSummaryResponse;
        }>({
          query,
          variables: { getPipelineSummaryInput },
          fetchPolicy: ApolloClientCache.NetworkOnly,
        });

        return results.data.getPipelineSummary;
      } catch (error) {
        logger.error(
          'Failed to fetch pipeline summaries',
          getPipelineSummaryInput,
          error,
        );
        return null;
      }
    },
  };
};

export default getPipelineSummary;
